import React, { useState } from "react";
import { createClaim } from "../lib/claims";
import { Modal, toast } from "./UI";

const TYPES = [
  { value: "not_received",   label: "Package not received at warehouse" },
  { value: "not_delivered",  label: "Package shipped but not delivered" },
  { value: "damaged",        label: "Package arrived damaged" },
  { value: "other",          label: "Other issue" },
];

export default function ClaimModal({ user, packages, onClose, onSaved }) {
  const [type,        setType]        = useState("not_received");
  const [packageId,   setPackageId]   = useState("");
  const [description, setDescription] = useState("");
  const [saving,      setSaving]      = useState(false);
  const [error,       setError]       = useState("");

  const save = async () => {
    if (!description.trim()) { setError("Please describe your issue."); return; }
    setSaving(true); setError("");
    try {
      await createClaim({
        customerEmail: user.email,
        customerName:  user.name,
        packageId,
        type,
        description,
      });
      toast("Claim submitted! We will review it shortly.");
      onSaved();
      onClose();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title="Open a claim" onClose={onClose} maxWidth={480}>
      <p style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: 16 }}>
        Having an issue with a package? Let us know and we will look into it as soon as possible.
      </p>
      {error && <div className="error-msg">{error}</div>}

      <div className="form-row">
        <label>Issue type</label>
        <select value={type} onChange={e => setType(e.target.value)}>
          {TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      </div>

      <div className="form-row">
        <label>Related package (optional)</label>
        <select value={packageId} onChange={e => setPackageId(e.target.value)}>
          <option value="">— Select a package —</option>
          {packages.map(p => (
            <option key={p.id} value={p.id}>
              {p.id} · {p.description || "Package"} ({p.status})
            </option>
          ))}
        </select>
      </div>

      <div className="form-row">
        <label>Describe the issue *</label>
        <textarea
          rows={4}
          value={description}
          onChange={e => setDescription(e.target.value)}
          placeholder="Please provide as much detail as possible..."
        />
      </div>

      <div className="modal-footer">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? "Submitting..." : "Submit claim"}
        </button>
      </div>
    </Modal>
  );
}
